export const fieldTypes = {
  Undefined: 0,
  Number: 1,
  Text: 2,
  Time: 3,
  Date: 4,
  Address: 5,
  PhoneNumber: 6,
  EmailAddress: 7
};